export enum PlatformCostType {
  Percentage = 'percentage',
  FixedAmount = 'fixedAmount',
  Mixed = 'mixed',
}

export interface PlatformCost {
  type: PlatformCostType;
  value: number;
  extraAmount?: number;
  selected?: boolean;
}
